/**
 * Cart Legacy Fixed Script
 * Properly handles localStorage updates after cart item removal
 */

console.log("Cart Legacy Fixed Script loaded");

// Function to update localStorage with current cart items
function updateLegacyProductIdsInLocalStorage() {
  try {
    // Get current localStorage for comparison
    const currentStorage = JSON.parse(
      localStorage.getItem("legacy_product_ids") || "{}"
    );
    console.log("DEBUG: Current localStorage before update:", currentStorage);

    const legacyIds = {};

    // Get all cart items with legacy product IDs from main cart
    document
      .querySelectorAll("#main-cart-items [legacy_product_id]")
      .forEach((item) => {
        const variantId = item
          .querySelector("[data-quantity-variant-id]")
          ?.getAttribute("data-quantity-variant-id");
        const legacyId = item.getAttribute("legacy_product_id");

        if (variantId && legacyId && legacyId !== "") {
          legacyIds[variantId] = legacyId;
        }
      });

    // Get all cart items with legacy product IDs from cart drawer (using drawer prefix)
    document
      .querySelectorAll("#CartDrawer-CartItems [drawer_legacy_product_id]")
      .forEach((item) => {
        const variantId = item
          .querySelector("[data-quantity-variant-id]")
          ?.getAttribute("data-quantity-variant-id");
        const legacyId = item.getAttribute("drawer_legacy_product_id");

        if (variantId && legacyId && legacyId !== "") {
          legacyIds[variantId] = legacyId;
        }
      });

    // Update localStorage
    if (typeof Storage !== "undefined") {
      localStorage.setItem("legacy_product_ids", JSON.stringify(legacyIds));

      // Compare old vs new
      const removedItems = Object.keys(currentStorage).filter(
        (key) => !legacyIds[key]
      );
      const addedItems = Object.keys(legacyIds).filter(
        (key) => !currentStorage[key]
      );

      console.log(
        "DEBUG: Updated localStorage with legacy product IDs:",
        legacyIds
      );
      if (removedItems.length > 0) {
        console.log("DEBUG: Removed items from localStorage:", removedItems);
      }
      if (addedItems.length > 0) {
        console.log("DEBUG: Added items to localStorage:", addedItems);
      }

      // Update global variables
      if (window.cartLegacyProductIds) {
        window.cartLegacyProductIds = legacyIds;
      }
      if (window.cartDrawerLegacyProductIds) {
        window.cartDrawerLegacyProductIds = legacyIds;
      }
      if (window.checkoutLegacyProductIds) {
        window.checkoutLegacyProductIds = legacyIds;
      }
    }
  } catch (error) {
    console.log("DEBUG: Error updating localStorage:", error);
  }
}

// Wait for DOM to be ready and cart elements to be available
document.addEventListener("DOMContentLoaded", function () {
  console.log("DEBUG: DOM loaded, setting up cart remove button override");

  // Override the CartItems updateQuantity method with better timing
  if (customElements.get("cart-items")) {
    const CartItemsElement = customElements.get("cart-items");
    const originalUpdateQuantity = CartItemsElement.prototype.updateQuantity;

    CartItemsElement.prototype.updateQuantity = function (
      line,
      quantity,
      name,
      variantId
    ) {
      console.log("DEBUG: updateQuantity called with:", {
        line,
        quantity,
        name,
        variantId,
      });

      // Call the original method
      const result = originalUpdateQuantity.call(
        this,
        line,
        quantity,
        name,
        variantId
      );

      // Update localStorage if quantity is 0 (item removal)
      if (quantity === 0) {
        console.log(
          "DEBUG: Item removal detected (quantity=0), updating localStorage"
        );

        // Wait longer for DOM to update after cart removal
        setTimeout(() => {
          updateLegacyProductIdsInLocalStorage();
        }, 1000); // Increased delay to ensure DOM is updated
      }

      return result;
    };
  }

  // Also listen for the cart-item-update event with longer delay
  document.addEventListener("cart-item-update", function (event) {
    console.log("DEBUG: cart-item-update event received");
    setTimeout(() => {
      updateLegacyProductIdsInLocalStorage();
    }, 1000); // Increased delay
  });
});

// Listen for clicks on remove buttons with longer delay
document.addEventListener("click", function (event) {
  if (
    event.target.closest("cart-remove-button") ||
    event.target.closest('[id^="Remove-"]') ||
    event.target.closest('a[href*="/cart/change"][href*="quantity=0"]')
  ) {
    console.log("DEBUG: Remove button click detected via event delegation");
    setTimeout(() => {
      updateLegacyProductIdsInLocalStorage();
    }, 1000); // Increased delay
  }
});

// Make the function globally available
window.updateLegacyProductIdsInLocalStorage =
  updateLegacyProductIdsInLocalStorage;

console.log("DEBUG: Cart Legacy Fixed Script initialized");
